import VIEWPORTS from '../plugins/viewports'
import PARTSLOADER from '../plugins/partsloader'
import CONTENT_TITLE from '../plugins/contentTitle'
import CURSOR_FOLLOWER from '../plugins/cursorFollower'

// スクロールして画面エリアに入ったら要素を表示する lazydisp
import LAZYDISP from '../plugins/lazydisp'

// IEでのpictureタグ対応
import IE_SRCSET from '../plugins/polyfill-ie-srcset'

// IE11でSVGの外部参照を有効にする
import 'svgxuse'


const [mq] = [window.matchMedia('(max-width: 899px)')]

export default function INIT() {

  IE_SRCSET();

  /*****
   * Promise
   */
  window.load = {
    'header': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'footer': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'mapScript': new $.Deferred, // googlemapAPIのURLパラメータでresolveします
    'loadHtml': new $.Deferred, // すべてのLoad Htmlが完了したらresolveする
  }

  window.load['loadHtml'].then(() => document.dispatchEvent( new CustomEvent('loadHtml') ) );

  //header.html, footer.html読み込み
  PARTSLOADER([
    {
      name: 'footer',
      loadhtml: '/asset/html/footer.html?ts=20220415',
      target: 'footer',
      method:'replaceWith',
      callback(){
        $('footer [data-plugin="getCopyright"]').getCopyright();
        $('.footer-service').before($('.breadcrumbs'));
      }
    },
    {
      name: 'header',
      loadhtml: '/asset/html/header.html?ts=20220415',
      target: 'header',
      method:'replaceWith',
      callback(r,_){
        $('header .p-gnav').currentMenu({mode:1,default:999});
        $('header .p-gnav__subnav').currentMenu({mode:0,default:999});
        $('header .p-gnav__item').each( function(){
          const $indicator = $(`<button class="p-gnav__item__indicator">`)
          if( mq.matches ) {
            if( this.querySelectorAll('.p-gnav__subnav-list').length ) {
              $(this).append( $indicator )
            }
            $(this).find('.p-gnav__subnav-list').slideUp();
            $indicator.on('click', ()=>{
              $(this).find('.p-gnav__subnav-list').slideToggle();
              $indicator.toggleClass('is-active');
            });
          }
        });



      }
    }
  ])
  // プライバシー・会社概要・サイトマップのコンテンツタイトル
  CONTENT_TITLE({
    'sitemap':'<span>SITEMAP</span><small>サイトマップ</small>',
    'privacy':'<span>PRIVACY POLICY</span><small>プライバシーポリシー</small>',
    'profile':'会社概要'
  })

  // DOM Ready
  $(() => {
    // <body>にクラス付与
    $.bodyClass();
    // htmlデータ読み込み
    $('[data-load-html]').loadHtml();
    // カレントメニュー
    $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});
    // ページングテキスト
    $.pagingText({
      prev:'Prev',
      next:'Next',
      list:'List'
    })
    // ページトップリンクをスクロール量で表示するサンプル
    $.scrollspy({
      trigger:200,
      onBefore(/* pos */) {
        $('.p-pagetop__wrap').addClass('hidden');
      },
      onAfter() {
        $('.p-pagetop__wrap').removeClass('hidden');
      }
    })

    $.when( window.load['loadHtml'] ).then( () => {

      // lazydisp
      LAZYDISP('[data-lazydisp]');

      // マウス追従
      if( !mq.matches ) CURSOR_FOLLOWER(5); //関数の使用
    });

    // window.loadを待たずにページ表示
    document.documentElement.style = "";
  })

}